/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export const inlineEditAcceptId = 'editor.action.inlineEdit.accept';
export const inlineEditRejectId = 'editor.action.inlineEdit.reject';
export const inlineEditJumpToId = 'editor.action.inlineEdit.jumpTo';
export const inlineEditJumpBackId = 'editor.action.inlineEdit.jumpBack';
